import {Environment} from './environment.model';

export const environment: Environment = {
  baseUrl: 'https://api-integration.viessmann-climatesolutions.com/planning-adviser/schematic-browser',
  serviceWorker: true,
  production: true,
};
